import React from 'react';
import courtImg from './basketball-ground.png';

const courtStyle = {
  wrapper: {
    textAlign: 'center',
    maxWidth: '800px',
    margin: '0 auto',
    padding: '20px 0',
  },
  divisionName: {
    color: '#090C82',
    fontSize: '1rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '2px',
    marginBottom: '4px',
  },
  gameTitle: {
    color: '#090C82',
    fontSize: '1.5rem',
    fontWeight: 700,
    marginBottom: '4px',
  },
  gameDescription: {
    fontSize: '0.95rem',
    color: '#333',
    marginBottom: '24px',
  },
  courtContainer: {
    position: 'relative',
    width: '100%',
    maxWidth: '650px',
    margin: '0 auto 30px',
  },
  courtImage: {
    width: '100%',
    height: 'auto',
    display: 'block',
  },
  playerName: {
    position: 'absolute',
    color: '#fff',
    fontSize: '0.7rem',
    fontWeight: 600,
    textAlign: 'center',
    textShadow: '0 1px 3px rgba(0,0,0,0.7)',
    whiteSpace: 'nowrap',
    transform: 'translate(-50%, -50%)',
    background: 'rgba(0,0,0,0.45)',
    padding: '3px 8px',
    borderRadius: '3px',
  },
  sectionLine: {
    fontSize: '0.9rem',
    marginBottom: '6px',
    color: '#333',
  },
  sectionLabel: {
    fontWeight: 700,
  },
  sectionNames: {
    color: '#090C82',
  },
};

/*
 * Basketball court positions mapped to percentage coordinates on the horizontal court.
 * Order matches BASKETBALL_POSITIONS in fieldGrid.js:
 *   Row 1: Point Guard, Shooting Guard
 *   Row 2: Small Forward
 *   Row 3: Power Forward, Centre
 */
const POSITION_COORDS = [
  // Row 1: Point Guard (back court left), Shooting Guard (back court upper)
  { top: '55%', left: '25%' },
  { top: '25%', left: '30%' },
  // Row 2: Small Forward (mid court)
  { top: '50%', left: '50%' },
  // Row 3: Power Forward (front court upper), Centre (paint area)
  { top: '25%', left: '70%' },
  { top: '55%', left: '78%' },
];

function formatPlayerLabel(player) {
  if (!player || !player.name) return '';
  let label = player.name;
  if (player.number) label += ' #' + player.number;
  if (player.isCaptain) label += ' (c)';
  return label;
}

function formatListSection(players) {
  if (!players || players.length === 0) return '';
  return players
    .filter((p) => p.name)
    .map((p) => formatPlayerLabel(p))
    .join(',  ');
}

function formatOutSection(players) {
  if (!players || players.length === 0) return '';
  return players
    .filter((p) => p.name)
    .map((p) => {
      let label = p.name;
      if (p.number) label += ' #' + p.number;
      if (p.reason) label += ' (' + p.reason + ')';
      if (p.isCaptain) label += ' (c)';
      return label;
    })
    .join(',  ');
}

export function BasketballCourt({ divisionName, gameTitle, gameDescription, selectionData }) {
  const field = selectionData.field || [];
  const interchange = selectionData.interchange || [];
  const playerIn = selectionData.in || [];
  const playerOut = selectionData.out || [];

  return (
    <div style={courtStyle.wrapper}>
      {divisionName && (
        <div style={courtStyle.divisionName}>{divisionName} Team Selections</div>
      )}
      {gameTitle && <div style={courtStyle.gameTitle}>{gameTitle}</div>}
      {gameDescription && <div style={courtStyle.gameDescription}>{gameDescription}</div>}

      <div style={courtStyle.courtContainer}>
        <img src={courtImg} alt="Basketball court" style={courtStyle.courtImage} />
        {field.map((player, idx) => {
          const label = formatPlayerLabel(player);
          if (!label || idx >= POSITION_COORDS.length) return null;
          const coords = POSITION_COORDS[idx];
          return (
            <div
              key={idx}
              style={{ ...courtStyle.playerName, top: coords.top, left: coords.left }}
            >
              {label}
            </div>
          );
        })}
      </div>

      {interchange.length > 0 && (
        <div style={courtStyle.sectionLine}>
          <span style={courtStyle.sectionLabel}>Bench - </span>
          <span style={courtStyle.sectionNames}>{formatListSection(interchange)}</span>
        </div>
      )}
      {playerIn.length > 0 && (
        <div style={courtStyle.sectionLine}>
          <span style={courtStyle.sectionLabel}>In - </span>
          <span style={courtStyle.sectionNames}>{formatListSection(playerIn)}</span>
        </div>
      )}
      {playerOut.length > 0 && (
        <div style={courtStyle.sectionLine}>
          <span style={courtStyle.sectionLabel}>Out - </span>
          <span style={courtStyle.sectionNames}>{formatOutSection(playerOut)}</span>
        </div>
      )}
    </div>
  );
}
